import { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Section from 'components/Section';
import TwoColumn from 'components/TwoColumn';
import ConnectedTextField from 'components/TextField';
import OrderStatusSelect from 'components/OrderStatusSelect';

import { OrderEditMainGeneral_order$key } from '__generated__/OrderEditMainGeneral_order.graphql';

type Props = {
  order: OrderEditMainGeneral_order$key;
};

const OrderEditMainGeneral: FC<Props> = props => {
  const order = useFragment(
    graphql`
      fragment OrderEditMainGeneral_order on Order {
        name
        tripDateStart
        tripDateEnd
        duration
      }
    `,
    props.order
  );

  return (
    <Section id="general" title="Bendra informacija">
      <Stack spacing={4}>
        <ConnectedTextField
          fullWidth
          name="adminComment"
          label="Užsakymą tvarkantis darbuotojas"
        />

        <OrderStatusSelect />

        <TextField
          fullWidth
          disabled
          label="Kelionės pavadinimas"
          variant="standard"
          value={order.name}
        />

        <TwoColumn
          left={
            <TextField
              fullWidth
              disabled
              label="Kelionės pradžia"
              variant="standard"
              value={order.tripDateStart}
            />
          }
          right={
            <TextField
              fullWidth
              disabled
              label="Kelionės pabaiga"
              variant="standard"
              value={order.tripDateEnd}
            />
          }
        />

        <TextField
          fullWidth
          disabled
          label="Kelionės trukmė"
          variant="standard"
          value={order.duration}
        />
      </Stack>
    </Section>
  );
};

export default OrderEditMainGeneral;
